module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAADd3d3c3Nzc3NzX19fc3Nzc3Nzc3NzPz8/d3d3f39/c3Nz2oh2CAAAAC3RSTlMA779wIICf3xDfEJchMFEAAAB8SURBVBjTYwACjqDqjcoODGDAor0bCLZBeIa7wUAYxGbdDQUBQI41jLMZqEMaxtnowMC2Gw4UGLwRnB1ALXCwlUEbwdnEII3g7GTYjQRQOdUI9kZUA6KBJNw9qxGcLQxMCE4CikORvYDiOXRvM7Bkgy2BBY+R9HbVBiADAEuSoC3OPW/QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/004.png
// module id = /Y1p
// module chunks = 1